import React, {useMemo, useState} from 'react';

import {Button, Grid, Icon} from '@material-ui/core';
import {Card, Form, Col, InputGroup} from 'react-bootstrap';
import {useQNAUIContext} from "../../../contexts/QNAUIContext";
import {orderStatusOptions, replyStatusOptions} from "../QNATable/ui.helpers";
import {format} from "date-fns";

const toDay = format(new Date(), 'yyyy-MM-dd');

export function QNAFilter() {
  const context = useQNAUIContext();

  const {queryParams, setQueryParams} = useMemo(() => ({
    queryParams: context.queryParams,
    setQueryParams: context.setQueryParams,
  }), [context]);

  const [filter, setFilter] = useState(queryParams.filter);

  const handleChangeFilter = (key) => (e) => setFilter({...filter, [key]: e.target.value});
  const handleSubmit = (e) => {
    e.preventDefault();
    const _filter = {
      ...filter,
      ordStartDt: filter.ordStartDt ? format(new Date(filter.ordStartDt), 'yyyyMMdd') : '',
      ordEndDt: filter.ordEndDt ? format(new Date(filter.ordEndDt), 'yyyyMMdd') : '',
      csStartDt: filter.csStartDt ? format(new Date(filter.csStartDt), 'yyyyMMdd') : '',
      csEndDt: filter.csEndDt ? format(new Date(filter.csEndDt), 'yyyyMMdd') : '',
    }
    setQueryParams({...queryParams, filter: _filter});
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Card>
        <Card.Body>
          <Card.Title as="h5" className="mb-5">
            <Icon color="secondary" className="mr-2 align-middle">search</Icon>
            검색
          </Card.Title>
          <hr className="mb-10" />

          <Grid container>
            <Grid item xs={6} md={3}>
              <Form.Group as={Col} controlId="ordNo">
                <Form.Label>주문번호</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="주문번호를 입력하세요."
                  value={filter.ordNo}
                  onChange={handleChangeFilter('ordNo')}
                />
              </Form.Group>
            </Grid>

            <Grid item xs={6} md={3}>
              <Form.Group as={Col} controlId="ansSttsCd">
                <Form.Label>답변 상태</Form.Label>
                <Form.Control
                  as="select"
                  value={filter.ansSttsCd}
                  onChange={handleChangeFilter('ansSttsCd')}
                >
                  <option value="">선택안함</option>
                  {replyStatusOptions.map(opt => (
                    <option key={opt.key} value={opt.key}>{opt.label}</option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Grid>

            <Grid item xs={6} md={3}>
              <Form.Group as={Col} controlId="ordSttsCd">
                <Form.Label>주문 상태</Form.Label>
                <Form.Control
                  as="select"
                  value={filter.ordSttsCd}
                  onChange={handleChangeFilter('ordSttsCd')}
                >
                  <option value="">선택안함</option>
                  {orderStatusOptions.map(opt => (
                    <option key={opt.key} value={opt.key}>{opt.label}</option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Grid>

            <Grid item xs={6} md={3}>
              <Form.Group as={Col} controlId="ordUserNm">
                <Form.Label>주문자명</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="주문자명을 입력하세요."
                  value={filter.ordUserNm}
                  onChange={handleChangeFilter('ordUserNm')}
                />
              </Form.Group>
            </Grid>

            <Grid item xs={12} md={6}>
              <Form.Group as={Col}>
                <Form.Label>주문 일자</Form.Label>
                <InputGroup>
                  <Form.Control
                    id="ordStartDt"
                    type="date"
                    max={filter.ordEndDt}
                    value={filter.ordStartDt}
                    placeholder="yyyy. mm. dd"
                    aria-describedby="basic-addon1"
                    onChange={handleChangeFilter('ordStartDt')}
                  />
                  <InputGroup.Prepend>
                    <InputGroup.Text>~</InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    id="ordEndDt"
                    type="date"
                    min={filter.ordStartDt}
                    max={toDay}
                    value={filter.ordEndDt}
                    placeholder="yyyy. mm. dd"
                    aria-describedby="basic-addon2"
                    onChange={handleChangeFilter('ordEndDt')}
                  />
                </InputGroup>
              </Form.Group>
            </Grid>

            <Grid item xs={12} md={6}>
              <Form.Group as={Col}>
                <Form.Label>문의 일자</Form.Label>
                <InputGroup>
                  <Form.Control
                    id="csStartDt"
                    type="date"
                    max={filter.csEndDt}
                    value={filter.csStartDt}
                    placeholder="yyyy. mm. dd"
                    aria-describedby="basic-addon1"
                    onChange={handleChangeFilter('csStartDt')}
                  />
                  <InputGroup.Prepend>
                    <InputGroup.Text>~</InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control
                    id="csEndDt"
                    type="date"
                    min={filter.csStartDt}
                    max={toDay}
                    value={filter.csEndDt}
                    placeholder="yyyy. mm. dd"
                    aria-describedby="basic-addon2"
                    onChange={handleChangeFilter('csEndDt')}
                  />
                </InputGroup>
              </Form.Group>
            </Grid>

            <Grid item xs={12} className="text-right pl-3 pr-3">
              <Button
                type="submit"
                variant="contained"
                color="secondary"
                size="large"
                className="w-130px"
              >
                검색
              </Button>
            </Grid>
          </Grid>
        </Card.Body>
      </Card>
    </Form>
  );
}
